import DeleteDialog from './DeleteDialog.jsx';
import HistoryDialog from './HistoryDialog.jsx';
import GiaHanDialog from './GiaHanDialog.jsx';
import SuspendedDialog from './SuspendedDialog.jsx';
import ConfirmDialog from './ConfirmDialog.jsx';
import ThuHoiDialog from './ThuHoiDialog.jsx';
import XuLyYeuCau from './XuLyYeuCau.jsx';
import TruongPhongThuHoiDialog from './TruongPhongThuHoiDialog.jsx';
import ChiTietDonDialog from './ChiTietDonDialog.jsx';
import MaTraCuuDialog from './MaTraCuuDialog.jsx';
import ChiTietDoiTuongThanhTraDialog from './ChiTietDoiTuongThanhTraDialog.jsx';
import SearchKeHoachTT from './SearchKeHoachTT.jsx';

export {
  DeleteDialog,
  HistoryDialog,
  GiaHanDialog,
  SuspendedDialog,
  ConfirmDialog,
  ThuHoiDialog,
  XuLyYeuCau,
  TruongPhongThuHoiDialog,
  ChiTietDonDialog,
  MaTraCuuDialog,
  ChiTietDoiTuongThanhTraDialog,
  SearchKeHoachTT
}



// WEBPACK FOOTER //
// ./src/components/modules/dialog/index.js